
<template>

  <img class="block w-full max-w-[260px] mx-auto" src="../images/activity-2-part-1-blankets.png" alt="Stack of green blankets" />

  <p class="mt-6 text-neutral-700">

    If you're on the road longer than you anticipated,
    
    you'll need to find a place to rest for the night—especially if you're near a "sundown town"
    
    (a town that wouldn't let African Americans stay past sunset).
    
    You'll need to spend the night in your vehicle if the nearby hotels are for whites only.
  
  </p>

</template>
